export function buildInvoiceNavigation<T extends { Id: string }>(
  entities: T[],
  currentId: string | null
) {
  const currentIndex = entities.findIndex(({ Id }) => Id === currentId);
  let prevItem: T | null = null;
  let currentItem: T | null = null;
  let nextItem: T | null = null;

  if (currentIndex !== -1) {
    prevItem = currentIndex > 0 ? entities[currentIndex - 1] : null;
    currentItem = entities[currentIndex];
    nextItem =
      currentIndex < entities.length - 1 ? entities[currentIndex + 1] : null;
  }

  return {
    prev: prevItem,
    current: currentItem,
    next: nextItem,
  };
}
